<div class='SelectUsersWizardStep'>
  <app-table (rowSelected)='onRowSelection($event)' [columns]='tableColumns' [dataSourceParams]='tableDatasourceParams'
             [dataSource]='tableDataSource'
             [filterGroups]='tableFilterGroups' [preselectedIdentifier]="'account_id'"
             [preselected]='preselected' [selectable]='true'></app-table>
</div>